import { render, staticRenderFns } from "./BaseFormGroupInput.vue?vue&type=template&id=245eb05c&"
import script from "./BaseFormGroupInput.vue?vue&type=script&lang=js&"
export * from "./BaseFormGroupInput.vue?vue&type=script&lang=js&"
import style0 from "./BaseFormGroupInput.vue?vue&type=style&index=0&id=245eb05c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports